import UiToast from './function-call';
import { isVue2 } from 'vue-demi';
function withInstall(options) {
  options.install = app => {
    const {
      name
    } = options;
    app.component(name, options);
    isVue2 ? app.prototype.$toast = options : app.config.globalProperties.$toast = options;
  };
  return options;
}
export default withInstall(UiToast);